var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * react-final-form Filed (Radio)
 */
import { useCallback } from 'react';
import { Field } from 'react-final-form';
import { RadioFieldBase } from '@/components/functional/Form/RadioField/RadioFieldBase';
export const RadioField = (props) => {
    const { isNumberValue = false, name } = props, otherProps = __rest(props
    /** 入力値をnumber型としてparseする */
    , ["isNumberValue", "name"]);
    /** 入力値をnumber型としてparseする */
    const parseValueAsNumber = useCallback((value) => typeof value === 'string' ? parseInt(value, 10) : value, []);
    return (_jsx(Field, Object.assign({}, otherProps, { component: RadioFieldBase, name: name, parse: isNumberValue ? parseValueAsNumber : undefined, type: 'radio' })));
};
